import { type ExtraValues, type PlatformEvent } from '../types';

export const pdAdBannerShown = (extra?: ExtraValues): PlatformEvent => {
  return {
    type: 'show',
    created: Date.now(),
    user_properties: {},
    event_properties: {
      name: 'ad',
      ...(extra && { ...extra.event_properties }),
    },
  };
};
